// src/hooks/useAttendance.js
import React, { useState, useCallback } from 'react';

const useAttendance = (hostelName = "Elite Residency") => {
  const [attendanceLogs, setAttendanceLogs] = useState({ self: [], compulsory: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const markAttendance = useCallback(async (type, method = 'self', roomNumber = '') => {
    setIsLoading(true);
    setError(null);

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, { 
          enableHighAccuracy: true, timeout: 8000 
        });
      });

      const { latitude, longitude } = position.coords;

      const newLog = {
        id: Date.now(),
        type,
        method,
        roomNumber: roomNumber || "N/A",
        latitude: latitude.toFixed(5),
        longitude: longitude.toFixed(5),
        timestamp: new Date().toLocaleString(),
        status: 'success'
      };

      setAttendanceLogs(prev => ({
        ...prev,
        [method]: [newLog, ...prev[method]]
      }));

      return newLog;
    } catch (err) {
      const msg = err.message.includes("denied") 
        ? "Location access denied. Please allow GPS." 
        : "Failed to mark attendance. Try again.";
      setError(msg);
      throw new Error(msg);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { attendanceLogs, isLoading, error, markAttendance };
};

export default useAttendance;